import React, { Fragment } from "react";
import {
  Wrapper,
  ContentContainer,
  LinksContainer,
  TitleStyled,
  SubtitleStyled,
  LinkStyled,
  TitleContainer,
} from "./styles";

function SitemapWrapper(props) {
  return (
    <Fragment>
      <TitleContainer>
        <TitleStyled>Site Map</TitleStyled>
      </TitleContainer>

      <Wrapper>
        <ContentContainer>
          <SubtitleStyled>About Hiredly</SubtitleStyled>
          <LinksContainer>
            <LinkStyled href="/about-us">About Us</LinkStyled>
            <LinkStyled href="/contact-us">Contact Us</LinkStyled>
            <LinkStyled href="/faq">Frequently Asked Questions</LinkStyled>
            <LinkStyled href="/newsroom">Newsroom</LinkStyled>
            <LinkStyled href="https://x.hiredly.com/">Hiredly X</LinkStyled>
          </LinksContainer>
        </ContentContainer>
        <ContentContainer>
          <SubtitleStyled>For Jobseekers</SubtitleStyled>
          <LinksContainer>
            <LinkStyled href="/advice">Advice</LinkStyled>
            <LinkStyled href="/sitemap/advice-articles">
              Browse Advice Articles
            </LinkStyled>
            <LinkStyled href="/companies">Explore Companies</LinkStyled>
            <LinkStyled href="/jobs">Explore Job Opportunities</LinkStyled>
            <LinkStyled href="/drop-resume">Send Us Your Resume</LinkStyled>
          </LinksContainer>
        </ContentContainer>
        <ContentContainer>
          <SubtitleStyled>For Employers</SubtitleStyled>
          <LinksContainer>
            <LinkStyled href="/employer">Why Hiredly</LinkStyled>
            <LinkStyled href="/employer/easy">Simplify Hiring</LinkStyled>
          </LinksContainer>
        </ContentContainer>
        <ContentContainer>
          <SubtitleStyled>Terms of Use</SubtitleStyled>
          <LinksContainer>
            <LinkStyled href="/community-guidelines">
              Community Guidelines
            </LinkStyled>
            <LinkStyled href="/privacy-policy">Privacy Policy</LinkStyled>
            <LinkStyled href="/terms-and-conditions">
              Terms and Conditions
            </LinkStyled>
          </LinksContainer>
        </ContentContainer>
        <ContentContainer>
          <SubtitleStyled>Our Partners</SubtitleStyled>
          <LinksContainer>
            <LinkStyled href="https://x.hiredly.com/aaa">
              AirAsia Academy
            </LinkStyled>
            <LinkStyled href="https://x.hiredly.com/itrainasia">
              iTrain Asia
            </LinkStyled>
            <LinkStyled href="https://x.hiredly.com/akademiga">
              Akademi GA
            </LinkStyled>
            <LinkStyled href="https://x.hiredly.com/lead">LEAD</LinkStyled>
            <LinkStyled href="https://x.hiredly.com/cima">CIMA</LinkStyled>
            <LinkStyled href="https://x.hiredly.com/forwardschool">
              Forward School
            </LinkStyled>
            <LinkStyled href="https://x.hiredly.com/shrdc">SHRDC</LinkStyled>
          </LinksContainer>
        </ContentContainer>
        <ContentContainer>
          <SubtitleStyled>Browse Job Opportunities</SubtitleStyled>
          <LinksContainer>
            <LinkStyled href="/sitemap/jobs-by-company">
              Jobs by Company
            </LinkStyled>
            <LinkStyled href="/sitemap/jobs-by-experience-level">
              Jobs by Experience Level
            </LinkStyled>
            <LinkStyled href="/sitemap/jobs-by-type">
              Jobs by Job Type
            </LinkStyled>
            <LinkStyled href="/sitemap/jobs-by-location">
              Jobs by Location
            </LinkStyled>
            <LinkStyled href="/sitemap/jobs-by-location-and-experience-level">
              Jobs by Location and Experience Level
            </LinkStyled>
            <LinkStyled href="/sitemap/jobs-by-location-and-type">
              Jobs by Location and Job Type
            </LinkStyled>
            <LinkStyled href="/sitemap/jobs-by-location-and-specialisation">
              Jobs by Location and Specialisation
            </LinkStyled>
            <LinkStyled href="/sitemap/jobs-by-specialisation">
              Jobs by Specialisation
            </LinkStyled>
            <LinkStyled href="/sitemap/jobs-by-specialisation-and-experience-level">
              Jobs by Specialisation and Experience Level
            </LinkStyled>
            <LinkStyled href="/sitemap/jobs-by-specialisation-and-type">
              Jobs by Specialisation and Job Type
            </LinkStyled>
          </LinksContainer>
        </ContentContainer>
      </Wrapper>
    </Fragment>
  );
}

export default SitemapWrapper;
